// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Duplicate(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Duplicate" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M2 6H4V20H18V22H2V6Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 2H22V18H6V2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Duplicate.js.map